import { render, staticRenderFns } from "./VideoHeaderStatus.vue?vue&type=template&id=12c402d5&scoped=true&"
import script from "./VideoHeaderStatus.vue?vue&type=script&lang=js&"
export * from "./VideoHeaderStatus.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeaderStatus.vue?vue&type=style&index=0&id=12c402d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c402d5",
  null
  
)

export default component.exports